<template>
  <v-theme-provider dark>
    <base-section
      id="features"
      class="accent text-center"
      space="56"
    >
      <base-icon class="mb-8">
        mdi-math-compass
      </base-icon>

      <base-section-heading
        color="transparent"
        title="다양한 부가기능"
      >
        전용 관리자 사이트와 어플리케이션으로 건물 설비를 통합관리해보세요.
      </base-section-heading>
      <v-responsive
        class="mx-auto"
        max-width="1000"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-img
                :src="require('@/assets/diagram-3.svg')"
                class="mx-auto mb-8"
                max-width="1000"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="card in cards"
              :key="card.title"
              cols="12"
              sm="4"
            >
              <base-info-card
                align="center"
                dark
                v-bind="card"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-responsive>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-camera-outline',
          title: '작업 전/후 사진 등록',
          text: '설비별 작업  진행여부 확인 및 완료 사진을 등록하세요.',
        },
        {
          icon: 'mdi-keyboard-outline',
          title: '이슈관리 기능',
          text: '관리 설비에서 발생한 불량 및 특이사항을 항목별로 관리하세요.',
        },
        {
          icon: 'mdi-file-download',
          title: 'DB 다운로드 기능',
          text: '현장에서 입력된 일지 별 점검현황을 파일로 바로 다운로드하세요.',
        },
      ],
    }),
  }
</script>
